import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { StoreState } from '../../types/store.type';
import { AppRoutes } from '../../routes';
import _ from 'lodash';

import './PalTripSideBar.scss';
import { ReservationUtils, TranslationUtils } from '../../utils';
import { NavbarLink } from '../../types/navbar.type';

export const PalTripSideBar = () => {
    const { reservation, guests } = useSelector((store: StoreState) => store.trip);

    let guestName, confirmationCode;

    if (guests) {
        const { first_name, last_name } = guests.primary;
        guestName = `${first_name} ${last_name}`;
    }

    if (reservation) {
        confirmationCode = reservation.confirmation_code
            ? ReservationUtils.formatConfirmationCode(reservation.confirmation_code)
            : reservation.id;
    }

    const options: NavbarLink[] = [
        {
            id: 'link-reservation',
            displayText: TranslationUtils.get('trip_overview_capitalized'),
            notifications: 0,
            route: AppRoutes.RESERVATION,
        },
        {
            id: 'link-pricing-details',
            displayText: TranslationUtils.get('pricing_details'),
            notifications: 0,
            route: AppRoutes.RECEIPT,
            indented: true,
        },
        {
            id: 'link-request-cancellation',
            displayText: TranslationUtils.get('request_cancellation'),
            notifications: 0,
            route: AppRoutes.CANCEL,
            indented: true,
        },
        {
            id: 'link-getting-there',
            displayText: TranslationUtils.get('getting_there_capitalized'),
            notifications: 0,
            route: AppRoutes.GETTING_THERE,
        },
        {
            id: 'link-in-the-home',
            displayText: TranslationUtils.get('features_and_amenities_capitalized'),
            notifications: 0,
            route: AppRoutes.IN_THE_HOME,
        },
    ];

    return (
        <div className="sidebar-container d-none d-lg-block">
            <div className="sidebar-data" tabIndex={0}>
                <div className="heading-caps-small-light my-trip">{TranslationUtils.get('my_trip')}</div>
                <div>
                    <b className="body-bold">{guestName ? guestName : ''}</b>
                </div>
                <div>
                    {TranslationUtils.get('confirmation')} : <b className="body-bold">{confirmationCode ? confirmationCode : ''}</b>
                </div>
            </div>
            <hr />
            <ul className="side-navlist">
                {options.map((item, index) => (
                    <li key={index}>
                        <NavLink to={item.route} id={item.id}>
                            <div className={`side-navlist-item ${item.indented ? 'indented' : ''}`}>
                                <p className="body-regular side-option"> {item.displayText}</p>
                                {item.notifications > 0 && <div className="side-notification">{item.notifications}</div>}
                            </div>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </div>
    );
};
